module.exports = __webpack_public_path__ + "media/images/desktop-UO_Globe-0a5742f903001b512d3f55ef3e938be7.jpg";